import { FC, useMemo } from 'react';

import { HSpacingContainer, ScrollableContainer, ScrollableItem, useBreakpoint } from '@hh.ru/magritte-ui';

import { useSelector } from 'src/hooks/useSelector';
import { EmployerHint } from 'src/models/vacancyWizard';

import Card from 'src/components/VacancySearchContent/components/VacancyWizard/Magritte/GalleryCard';

const GROUP_CARD_SIZE = 2;
const GROUP_CARD_SIZE_GT_M = 3;

const getGroupedHints = (array: Array<EmployerHint>, groupSize: number) => {
    const result = [];

    for (let i = 0; i < array.length; i += groupSize) {
        result.push(array.slice(i, i + groupSize));
    }

    return result;
};

const VacancySearchWizardGallery: FC = () => {
    const employerHits = useSelector((state) => state.vacancyWizard?.employerHits || []);

    const { isGtS, isGtM } = useBreakpoint();

    // Разделение на группы нужно для показа последнего элемента первым после скролла (т.к. он немного закрывается стрелочкой)
    // Например, при таком разбиении на размере М после скролла будет показан первым 3 элемент
    const groupedHintsGtS = useMemo(() => {
        if (!isGtS) {
            return [];
        }
        const groupCardSizeByScreen = isGtM ? GROUP_CARD_SIZE_GT_M : GROUP_CARD_SIZE;
        const groupCardSize =
            employerHits.length === groupCardSizeByScreen + 1 ? groupCardSizeByScreen + 1 : groupCardSizeByScreen;
        return getGroupedHints(employerHits, groupCardSize);
    }, [employerHits, isGtM, isGtS]);

    return (
        <ScrollableContainer showDotPages={isGtS} correction={0} correctionXS={15}>
            <HSpacingContainer default={12}>
                {isGtS
                    ? groupedHintsGtS.map((hints) => (
                          <ScrollableItem key={hints[0].id}>
                              <HSpacingContainer default={12}>
                                  {hints.map((hint) => (
                                      <Card key={hint.id} {...hint} />
                                  ))}
                              </HSpacingContainer>
                          </ScrollableItem>
                      ))
                    : employerHits.map((hint) => (
                          <ScrollableItem key={hint.id}>
                              <Card {...hint} />
                          </ScrollableItem>
                      ))}
            </HSpacingContainer>
        </ScrollableContainer>
    );
};

export default VacancySearchWizardGallery;
